export default {
  auth: state => state.auth,
  notify: state => state.notify,
  sidebar: state => state.settings.sidebar,
  size: state => state.settings.size,
  device: state => state.settings.device,

  permission_routes: state => state.permission.routes,

  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews

};
